import { Box } from '@mui/material';

import MessageList from './MessageList';
import MessageInput from './MessageInput';
import ClosedMessage from './ClosedMessage';
import CSATSurvey from './CSATSurvey';

interface MessageCenterChatProps {
    ticketId: number;
}

export default function MessageCenterChat({ ticketId }: MessageCenterChatProps) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', height: '100%' }}>
            <MessageList ticketId={ticketId} />
            <Box sx={{ padding: 2 }}>
                <CSATSurvey ticketId={ticketId} />
                <ClosedMessage ticketId={ticketId} />
                <MessageInput ticketId={ticketId} />
            </Box>
        </Box>
    );
}
